import React, { useState } from 'react'
import { ConnectAppModal } from './connectAppModal'
import './connectApp.scss'
import { Trans } from 'translations'

export const ConnectAppLink: React.FC = () => {
    const [connecting, setConnecting] = useState(false)

    return (
        <>
            <p className="body1 connect-app-link-row">
                <Trans
                    i18nKey="settings.personalSettings.serviceApps.connectApp.helpLink"
                    components={{
                        anchor: (
                            <button
                                type="button"
                                className="bk-link connect-app-link"
                                onClick={() => setConnecting(true)}
                            />
                        ),
                    }}
                />
            </p>
            {connecting && <ConnectAppModal onDismiss={() => setConnecting(false)} />}
        </>
    )
}
